
import { LINKCODE_SPLIT } from '@/constants';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/invite',
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import(/* webpackChunkName: "Invite" */ '@/views/Invite.vue')
  },
  {
    path: '/invite-pro',
    name: 'InvitePro',
    component: () => import(/* webpackChunkName: "InvitePro" */ '@/views/InvitePro.vue')
  },
  {
    path: '/beInvite',
    name: 'BeInvite',
    component: () => import(/* webpackChunkName: "BeInvite" */ '@/views/BeInvite.vue')
  },
  {
    path: '/mobile-invite',
    name: 'MobileInvite',
    component: () => import(/* webpackChunkName: "MobileInvite" */ '@/views/MobileInvite.vue')
  },
  {
    path: '/contacts-manage',
    name: 'ContactsManagePage',
    component: () => import(/* webpackChunkName: "ContactsManagePage" */ '@/views/ContactsManagePage.vue')
  },
  {
    path: '/contactsFormPage',
    name: 'ContactsFormPage',
    component: () => import(/* webpackChunkName: "ContactsFormPage" */ '@/views/ContactsFormPage.vue')
  },
  {
    path: '/contactsFormGroupPage',
    name: 'ContactsFormGroupPage',
    component: () => import(/* webpackChunkName: "ContactsFormGroupPage" */ '@/views/ContactsFormGroupPage.vue')
  },
  {
    path: '/contactsAddSearchPage',
    name: 'ContactsAddSearchPage',
    component: () => import(/* webpackChunkName: "ContactsAddSearchPage" */ '@/views/ContactsAddSearchPage.vue')
  },
  {
    path: '/contacts-select',
    name: 'ContactsSelectPage',
    component: () => import(/* webpackChunkName: "ContactsSelectPage" */ '@/views/ContactsSelectPage.vue')
  },
  {
    path: '/contactsInfo',
    name: 'ContactsInfo',
    component: () => import(/* webpackChunkName: "ContactsInfo" */ '@/views/ContactsInfo.vue')
  },
  {
    path: '/contactsInfoAdd',
    name: 'ContactsInfoAdd',
    component: () => import(/* webpackChunkName: "ContactsInfoAdd" */ '@/views/ContactsInfoAdd.vue')
  },
  {
    path: '/unsupport',
    name: 'UnSupportAccount',
    component: () => import(/* webpackChunkName: "UnSupportAccount" */ '@/views/UnSupportAccount.vue')
  },
  {
    path: '/from-company-invite',
    name: 'BeInviteCompany',
    component: () => import(/* webpackChunkName: "BeInviteCompany" */ '@/views/BeInviteCompany.vue')
  }
];

export const router = new Router({
  routes
});


router.beforeEach(async (to, from, next) => {
  const linkCode: any = to.query.linkCode;

  // 处理邀请码链接包含文案场景
  if (linkCode) {
    // QQ 浏览器会存在只有一个空格的现象，所以在这里做兼容
    const paramArr = linkCode.split(LINKCODE_SPLIT.replace(' ', ''));
    // 存在需要过滤的字符,重定向一下
    if (paramArr.length > 1) {
      next({
        path: to.path,
        query: { linkCode: paramArr[0] }
      });
      return;
    }
  }
  next();
});

export const getCurrentRoute = () => {
  return router.currentRoute;
};
